import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cyan, border } from "./fieldUi";

// The account menu for rig-service-only companies (WORKFLOW-AUDIT.md
// stage 2): Legal lives here instead of the main menu; the admin finds
// "Show all menu items" in Settings → Menu (a link here).
export default function AccountMenu({ isAdmin, onOpenMenuSettings, onOpenLegal, buttonStyle, inline = false }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(inline);
  const body = (
    <div data-testid="account-menu-body" style={inline ? { display: "flex", flexDirection: "column", gap: "8px" } : { position: "absolute", right: 0, top: "calc(100% + 6px)", zIndex: 30, minWidth: "260px", background: "#020817", border: `1px solid ${border}`, borderRadius: "8px", padding: "10px", display: "flex", flexDirection: "column", gap: "8px" }}>
      <button
        type="button"
        data-testid="account-legal"
        onClick={() => {
          if (!inline) setOpen(false);
          onOpenLegal();
        }}
        style={{ background: "none", border: `1px solid ${border}`, color: "rgba(255,255,255,0.85)", borderRadius: "6px", minHeight: "44px", padding: "0 12px", textAlign: "left", cursor: "pointer", fontFamily: "inherit", fontSize: "13px", letterSpacing: "1px" }}
      >
        {t("dashboard.nav.legalCenter")}
      </button>
      {/* "Show all menu items" lives in Settings → Menu (the admin's) */}
      {isAdmin && onOpenMenuSettings && (
        <button
          type="button"
          data-testid="account-menu-settings"
          onClick={() => {
            if (!inline) setOpen(false);
            onOpenMenuSettings();
          }}
          style={{ background: "none", border: `1px solid ${border}`, color: cyan, borderRadius: "6px", minHeight: "44px", padding: "0 12px", textAlign: "left", cursor: "pointer", fontFamily: "inherit", fontSize: "13px" }}
        >
          {t("account.menuSettings")}
        </button>
      )}
    </div>
  );
  if (inline) return body;
  return (
    <div style={{ position: "relative" }}>
      <button type="button" data-testid="account-menu" aria-expanded={open} onClick={() => setOpen(!open)} style={{ color: cyan, background: "none", border: `1px solid ${border}`, borderRadius: "4px", cursor: "pointer", fontSize: "11px", padding: "4px 12px", letterSpacing: "1px", ...(buttonStyle || {}) }}>
        {t("account.menu")} ▾
      </button>
      {open && body}
    </div>
  );
}
